<template>
  <div class="mb-4">
    <h5 class="mb-2">
      {{ "send_request_to_syste" | setText("Отправить запрос в систему") }}
    </h5>
    <button class="btn btn-info btn-icon mw" @click="sendRequest">
      {{ "create_query" | setText("Сформировать заявку") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$dialog
        .confirm(
          `*[${this.data.phone_control}]
          **IMEI1:[${
            this.data.imeis[0] ? this.data.imeis[0].number : ""
          }]  ***IMEI2:[${
            this.data.imeis[1] ? this.data.imeis[1].number : ""
          }]`,
          {
            okText: "Верно | To'g'ri",
            cancelText: "Нет | Yo'q",
          }
        )
        .then(() => {
          this.$loading(true);
          const action = "devices";
          const url = this.data.service.api_endpoint_url + action;
          const token = this.data.service.api_token;
          const method = "post";
          logger(this.$http, {
            name: "Запрос в BSS",
            url: url,
          });
          let data = {
            transaction: this.data.id,
            command: "attach",
            identificator_type: "msisdn",
            identificator_number: this.data.phone_control.replace("+", ""),
            device: {
              name: this.data.product_name,
              barcode: this.data.product_barcode,
            },
            imeis: this.data.imeis,
          };
          return this.$http({
            method: method,
            data: data,
            url: url,
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": `application/json`,
              "Vendor-Code": `cb`,
            },
          })
            .then((response) => {
              this.$loading(false);
              const data = response.data;
              if (data) {
                this.$emit("input", {
                  state: "sent",
                  body: JSON.stringify(data),
                });
              }

              logger(this.$http, {
                name: `Формирование запроса - BSS`,
                description: "",
                model_type: this.type,
                model_id: this.data.id,
              });

              return response.data;
            })
            .catch((error) => {
              this.$loading(false);
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
  },
  data: () => ({}),
  props: ["value", "data", "type"],
};
</script>
<style>
</style>
 